import * as React from 'react';
import '../types/index.esm.js';

/* Collection of utilities used by Sheets */
/* istanbul ignore file */
let focusable;
const setFocus = ref => {
  if (ref && ref.current) {
    ref.current.focus();
  }
};
const setFocusableElems = sheetRef => {
  if (sheetRef && sheetRef.current) {
    focusable = sheetRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  }
};
const setElementFocus = (sheetRef, focusFirstElement, hasModal) => {
  setFocusableElems(sheetRef);
  if (focusable?.length) {
    focusable[1]?.focus();
  } else {
    setFocus(sheetRef);
  }
};
const trapUpperBoundFocus = () => {
  focusable[focusable.length - 2]?.focus(); // Send focus to last element before boundary
};
const trapLowerBoundFocus = () => {
  focusable?.[1]?.focus(); // Send focus to first element after boundary
};
const defineSheetLayout = children => {
  const childrenArray = React.Children.toArray(children);
  const sheetLayoutObj = {
    get hasCloseButton() {
      return !!this.closeButtonElem;
    },
    get hasAlignment() {
      return !!this.hasCloseButton && React.isValidElement(this.closeButtonElem) && (this.closeButtonElem.props.alignment ?? 'right');
    },
    get layoutProps() {
      return this.hasCloseButton && {
        space: 'two',
        direction: this.hasAlignment === 'top' ? 'column' : 'row-reverse'
      };
    },
    get closeButtonLayoutProps() {
      return this.hasCloseButton && this.hasAlignment === 'top' && {
        alignSelf: 'end'
      };
    },
    closeButtonElem: childrenArray.find(child => React.isValidElement(child) && typeof child.type !== 'string' && child.type?.displayName?.match(/(EGDS|Uitk)SheetCloseButton/)),
    footerElem: childrenArray.find(child => React.isValidElement(child) && typeof child.type !== 'string' && child.type?.displayName?.match(/(EGDS|Uitk)SheetCloseFooter/)),
    childrenElem: childrenArray.filter(child => {
      if (React.isValidElement(child) && typeof child.type !== 'string' && child.type?.displayName) {
        // Regular expression to match "Uitk" or "EGDS" followed by "SheetCloseButton" or "SheetFooter"
        const sheetElemRegex = /^(EGDS|Uitk)(SheetCloseButton|SheetFooter)$/;
        return !sheetElemRegex.test(child.type.displayName);
      }
      return true; // This returns all the other elements
    })
  };
  return sheetLayoutObj;
};
/**
 * Add or remove the "has sheet" class name to the body element
 *
 * @param action 'add' | 'remove'
 * @returns target.add(className) || target.remove(className)
 */
const hasSheetClassName = action => {
  const className = 'has-uitk-sheet';
  const target = document.body.classList;
  return action === 'add' ? target.add(className) : target.remove(className);
};
export { defineSheetLayout, hasSheetClassName, setElementFocus, setFocus, setFocusableElems, trapLowerBoundFocus, trapUpperBoundFocus };